import { topbarSelector } from '../components/topbar.js';

const PADDING_PX = 170;

/**
 * Returns the total height of the header, including padding above and below.
 * This is a rough approximation, currently only used to ensure that the
 * crossheight transition between tables only transitions between relevant
 * values.
 */
function getCoursesPageHeaderHeight() {
  return PADDING_PX + (document.querySelector(topbarSelector)?.scrollHeight ?? 0);
}

export { getCoursesPageHeaderHeight };
//# sourceMappingURL=get-header-height.js.map
